/**
 * @Description: 用于存储产品模块中软件产品，字体信息相关接口
 */
import { ContentType, Method } from 'axios-mapper'
import https, { axiosHttpPost } from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { Route } from '@/constant/route'
import {
  FontsModel,
  FontsSearchModel,
  FontsPageSearchModel,
  FontsUpdateModel,
  IdsModel
} from '@/model/product/FontsModel'

const baseUrl = Route.product + '/fonts'

/**
 * 搜索分页数据
 */
export const pageSearchFonts = (param: FontsPageSearchModel) => {
  return https().request<RootObject<PageRespModel<FontsModel>>>(baseUrl.concat('/list'), Method.POST, param, ContentType.json)
}

/**
 * 搜索所有数据
 */
export const searchFonts = (param: FontsSearchModel) => {
  return https().request<RootObject<FontsModel[]>>(baseUrl.concat('/list/all'), Method.POST, param, ContentType.json)
}

/**
 * 根据ID查找数据
 */
export const getFonts = (id: number) => {
  return https().request<RootObject<FontsModel>>(baseUrl.concat('/get/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}

/**
 * 添加数据
 */
export const addFonts = (param: FormData) => {
  return axiosHttpPost(baseUrl.concat('/add'), param, ContentType.multipart)
  // return https().request<RootObject<any>>(baseUrl.concat('/add'), Method.POST, param, ContentType.multipart)
}

/**
 * 更新数据
 */
export const updateFontsFile = (param: FormData) => {
  return axiosHttpPost(baseUrl.concat('/update/font'), param, ContentType.multipart)
  // return https().request<RootObject<any>>(baseUrl.concat('/update/font'), Method.POST, param, ContentType.multipart)
}

/**
 * 更新数据
 */
export const updateFonts = (param: FontsUpdateModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update'), Method.POST, param, ContentType.json)
}

/**
 * 删除数据
 */
export const removeFonts = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 批量删除数据
 */
export const batchRemoveFonts = (param: IdsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/batch/remove'), Method.POST, param, ContentType.json)
}
